import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, TextField, Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RefreshIcon from '@mui/icons-material/Refresh';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function Browser() {
  const [url, setUrl] = useState('https://www.example.com');
  const [currentUrl, setCurrentUrl] = useState('https://www.example.com');
  const [history, setHistory] = useState(['https://www.example.com']);
  const [historyIndex, setHistoryIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleGo = (e) => {
    e.preventDefault();
    if (!url) return;
    if (url !== currentUrl) {
      const newHistory = history.slice(0, historyIndex + 1).concat([url]);
      setHistory(newHistory);
      setHistoryIndex(newHistory.length - 1);
      setCurrentUrl(url);
      setLoading(true);
    }
  };

  const goBack = () => {
    if (historyIndex > 0) {
      setHistoryIndex(historyIndex - 1);
      setCurrentUrl(history[historyIndex - 1]);
      setUrl(history[historyIndex - 1]);
      setLoading(true);
    }
  };

  const goForward = () => {
    if (historyIndex < history.length - 1) {
      setHistoryIndex(historyIndex + 1);
      setCurrentUrl(history[historyIndex + 1]);
      setUrl(history[historyIndex + 1]);
      setLoading(true);
    }
  };

  const refresh = () => {
    setLoading(true);
    setCurrentUrl(currentUrl); // reload iframe by changing key
  };

  const openInNewTab = () => {
    window.open(currentUrl, '_blank');
  };

  // Listen to iframe load
  const handleIframeLoad = () => setLoading(false);

  // Sync url when historyIndex changes (back/forward)
  useEffect(() => {
    setUrl(history[historyIndex]);
  }, [historyIndex]);

  return (
    <Box p={2}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="h5">Fureteur Web (Chrome simplifié)</Typography>
        <form onSubmit={handleGo} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <IconButton onClick={goBack} disabled={historyIndex === 0} size="small"><ArrowBackIcon /></IconButton>
          <IconButton onClick={goForward} disabled={historyIndex === history.length - 1} size="small"><ArrowForwardIcon /></IconButton>
          <IconButton onClick={refresh} size="small"><RefreshIcon /></IconButton>
          <TextField
            label="URL"
            size="small"
            value={url}
            onChange={e => setUrl(e.target.value)}
            style={{ flex: 1 }}
            autoComplete="off"
          />
          <Button type="submit" variant="contained" color="primary">Aller</Button>
          <IconButton onClick={openInNewTab} size="small" title="Ouvrir dans un nouvel onglet"><OpenInNewIcon /></IconButton>
        </form>
        <Box sx={{ height: 400, border: '1px solid #ccc', borderRadius: 1, overflow: 'hidden', position: 'relative' }}>
          {loading && <Box sx={{position:'absolute',top:0,left:0,right:0,bottom:0,display:'flex',alignItems:'center',justifyContent:'center',zIndex:2,background:'rgba(255,255,255,0.7)'}}><span>Chargement…</span></Box>}
          <iframe
            key={currentUrl}
            title="fureteur-web"
            src={currentUrl}
            width="100%"
            height="100%"
            style={{ border: 'none', minHeight: 400 }}
            onLoad={handleIframeLoad}
          />
        </Box>
      </Paper>
    </Box>
  );
}
